import { env } from "./config"
import { uri } from "./endpoints"

const CONST = {
    env,
    uri
}
export { CONST }